/* Store-local scheduled hours; Intl handles Mountain Standard/Daylight time. */
(() => {
  if (window.gearonimoOpenStatusLoaded) return;
  window.gearonimoOpenStatusLoaded = true;
  function storeIsOpen(now = new Date()) {
    try {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
        timeZone:'America/Denver',weekday:'short',hour:'2-digit',minute:'2-digit',hourCycle:'h23'
      }).formatToParts(now).map(part=>[part.type,part.value]));
      const minutes=Number(parts.hour)*60+Number(parts.minute);
      return minutes>=600 && minutes<(parts.weekday==='Sun'?960:1080);
    } catch (_) { return false; }
  }
  function update(){
    const open=storeIsOpen();
    document.querySelectorAll('[data-store-open-status]').forEach(badge=>{badge.hidden=!open;});
  }
  update();
  setInterval(update,15000);
  document.addEventListener('visibilitychange',update);
  document.addEventListener('shopify:section:load',update);
  window.addEventListener('pageshow',update);
})();